import GearMark from "@/components/GearMark";

const ITEMS = [
  "AWS Marketplace Acceleration",
  "Channel Sales Velocity",
  "Autonomous Co-Sell",
  "ACE CRM Sync",
  "Partner-Led Growth",
  "Private Offers",
  "Renewal Signals",
  "Marketplace Ops",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span className="flex items-center" key={`${t}-${hidden}`}>
        <span className="whitespace-nowrap px-8 font-mono text-[11px] uppercase tracking-[0.24em] text-inksoft">
          {t}
        </span>
        <GearMark size={13} className="opacity-60" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee"
      className="overflow-hidden border-y border-line bg-parchment/70 py-5"
    >
      <div className="marquee-track">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
